@if (label()) {
  <div class="tb-label">
    {{ label() }}@if (unit()) {<span class="tb-unit"> ({{ unit() }})</span>}
    @if (showNegative() && !readOnly()) {
      <label class="tb-symmetric-toggle">
        <input type="checkbox" [checked]="symmetric()" (change)="symmetric.set($any($event.target).checked)" />
        {{ 'HOLE_TOLERANCE.SYMMETRIC' | translate }}
      </label>
    }
  </div>
}

<div class="tb-wrapper" [ngClass]="{ 'tb-error': showError() && !editAsDesigned() }">

  <!-- Colored zone bar - fixed equal-width boxes -->
  <div class="tb-track">
    @if (showNegative()) {
      <div class="tb-zone tb-red"></div>
      <div class="tb-zone tb-yellow"></div>
      <div class="tb-zone tb-green"></div>
      <div class="tb-zone tb-yellow"></div>
      <div class="tb-zone tb-red"></div>
    } @else {
      <div class="tb-zone tb-green"></div>
      <div class="tb-zone tb-yellow"></div>
      <div class="tb-zone tb-red"></div>
    }
  </div>

  <!-- Threshold ticks & inputs -->
  <div class="tb-ticks">

    <!-- Center zero tick (only for bars with a negative side) -->
    @if (showNegative()) {
      <div class="tb-center-tick">
        <div class="tb-tick-line"></div>
        <span class="tb-center-label">0</span>
      </div>
    }

    <!-- Left ticks: only when showNegative=true -->
    @if (showNegative()) {
      @if (symmetric()) {
        <!-- Symmetric: readonly mirrors -->
        <div class="tb-tick tb-tick-left" [style.left.%]="pos1()">
          <div class="tb-tick-line"></div>
          @if (readOnly()) {
            <span class="tb-value">{{ -editInTolerance() }}</span>
          } @else {
            <input type="number" class="tb-input tb-input-readonly" [value]="-editInTolerance()" readonly tabindex="-1" step="any" />
          }
        </div>
        <div class="tb-tick tb-tick-left" [style.left.%]="pos2()">
          <div class="tb-tick-line"></div>
          @if (readOnly()) {
            <span class="tb-value">{{ -clampedInner() }}</span>
          } @else {
            <input type="number" class="tb-input tb-input-readonly" [value]="-clampedInner()" readonly tabindex="-1" step="any" />
          }
        </div>
      } @else {
        <!-- Asymmetric: editable left ticks -->
        <div class="tb-tick tb-tick-left" [style.left.%]="pos1()">
          <div class="tb-tick-line"></div>
          @if (readOnly()) {
            <span class="tb-value">{{ editInToleranceMin() }}</span>
          } @else {
            <input
              type="number"
              class="tb-input tb-input-editable"
              [value]="editInToleranceMin()"
              (change)="onInToleranceMinChange(+$any($event.target).value)"
              step="0.1"
              max="0"
            />
          }
        </div>
        <div class="tb-tick tb-tick-left" [style.left.%]="pos2()">
          <div class="tb-tick-line"></div>
          @if (readOnly()) {
            <span class="tb-value">{{ editAsDesignedMin() }}</span>
          } @else {
            <input
              type="number"
              class="tb-input tb-input-editable"
              [value]="editAsDesignedMin()"
              (change)="onAsDesignedMinChange(+$any($event.target).value)"
              step="0.1"
              max="0"
            />
          }
        </div>
      }
    }

    <!-- Right ticks: always shown -->
    <div class="tb-tick tb-tick-right" [style.left.%]="pos3()">
      <div class="tb-tick-line"></div>
      @if (readOnly()) {
        <span class="tb-value">{{ editAsDesigned() }}</span>
      } @else {
        <input
          type="number"
          class="tb-input tb-input-editable"
          [value]="editAsDesigned()"
          (input)="onAsDesignedInput(+$any($event.target).value)"
          (change)="onAsDesignedMaxChange(+$any($event.target).value)"
          step="0.1"
          min="0"
        />
      }
    </div>

    <div class="tb-tick tb-tick-right" [style.left.%]="pos4()">
      <div class="tb-tick-line"></div>
      @if (readOnly()) {
        <span class="tb-value">{{ editInTolerance() }}</span>
      } @else {
        <input
          type="number"
          class="tb-input tb-input-editable"
          [value]="editInTolerance()"
          (input)="onInToleranceInput(+$any($event.target).value)"
          (change)="onInToleranceMaxChange(+$any($event.target).value)"
          step="0.1"
          min="0"
        />
      }
    </div>

  </div>

  <!-- Side labels -->
  @if (showNegative()) {
    <span class="tb-side-label tb-side-left">{{ 'HOLE_TOLERANCE.TOO_SHORT' | translate }}</span>
  }
  <span class="tb-side-label tb-side-right">{{ 'HOLE_TOLERANCE.TOO_LONG' | translate }}</span>

</div>
